require('./rightsPortableView.scss');

// @ vendor
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { i18n } from 'core/i18n';
const { getFinalTitle, formatText, FormattedText } = i18n;

// @ commons
import { Accordion } from 'commonsComponents/accordion';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import { AccordionBody } from 'commonsComponents/accordionBody';
import { OKCover } from 'commonsComponents/OKCover';
import { OKLink } from 'commonsComponents/OKLink';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { InputSafe } from 'commonsComponents/inputSafe';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import { SignaturePattern } from 'components/signaturePattern/signaturePattern';
//import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';
import WizardError from 'components/commons/wizardError/wizardError';
import PortableProductsAccordion from 'components/myProfile/portableProductsAccordion/portableProductsAccordion';

// @ utils
import PersonalDataHelper from 'utilities/personalDataHelper';
import rightsProfileHelper from 'utilities/rightsProfileHelper';

// @actions
import rightsActions from 'actions/rightsProfile';


// @ constants
import { GDPR_PORTABLE_ID} from 'constants/operationTypes';
import {
    CARD_ECARD,
    CARD_CREDIT,
    CARD_DEBIT,
    PORTABILITY,
    EMAIL_REGEX
} from 'constants/index';

class RightsPortableView extends React.Component {
    constructor(props) {
        super(props);
        const total = props.immAccounts.get('byOrder').size + //accounts
            props.immPlans.size + //plans
            rightsProfileHelper.getTotalCardsByType(CARD_CREDIT, props.immCards) + //credit card
            rightsProfileHelper.getTotalCardsByType(CARD_DEBIT, props.immCards) + //debit card
            rightsProfileHelper.getTotalCardsByType(CARD_ECARD, props.immCards) + //ecard card
            props.immWallets.size + //wallets
            props.immFunds.size + //funds
            rightsProfileHelper.loansWithBalanceBiggerThanCero(true, true, props.immLoans)+ //mortgages
            rightsProfileHelper.loansWithBalanceBiggerThanCero(false, true, props.immLoans); //loans

        const { immProfileFields } = this.props;
        const oldEmailUser = PersonalDataHelper.getEmail(immProfileFields);
        const isValidEmail = this.isValidNewEmail(oldEmailUser);

        this.state = {
            thirdEmailUser: oldEmailUser,
            profileCheckAll: false,
            productsCheckAll: false,
            countCheckedList: 0,
            totalCountList: total,
            doActionChangeALl: false,
            showMovements: this.props.immRightsProfile.get('showMovements'),
            selectFilter: '',
            newEmailValid: isValidEmail,
            numberOfProductInfo: 4,
            showAllProductsInfo: false,
        }
    }

    componentWillReceiveProps (nextProps) {
        const { immProfileFields } = this.props;
        const { thirdEmailUser } = this.state
        const oldEmailUser = PersonalDataHelper.getEmail(immProfileFields);
        const nextEmailUser = PersonalDataHelper.getEmail(nextProps.immProfileFields);
        const isValidEmail = this.isValidNewEmail(nextEmailUser);

        !oldEmailUser && nextEmailUser && !thirdEmailUser && this.setState({
            newEmailValid: isValidEmail,
            thirdEmailUser: nextEmailUser
        })

    }

    componentWillUnmount () {
        this.props.rightsActions.resetRightsProfile();
    }

    // finish form
    onFinish = () => {
        const { thirdEmailUser } = this.state;
        this.props.rightsActions.postRights(PORTABILITY, thirdEmailUser);
    }

    // cancel form
    cancel  = () => {
        const { history } = this.props;
        history.push('/myprofile/rights');
    }

    // go to next step
    setNextStep = () => {
        const { immRightsProfile, rightsActions, immProfileFields } = this.props
        const { newEmailValid } = this.state;
        const idsToPrint = this.getIdsToPrint() || []
        const personalInfo = immRightsProfile.get('profileList', []);

        if ((immRightsProfile.get('visibleStepPortable') !== 2 || newEmailValid) &&
            (immRightsProfile.get('visibleStepPortable') !== 1 || idsToPrint.length || personalInfo.length)) {
            rightsActions.nextStepPortable();
        }

        if (immRightsProfile.get('visibleStepPortable') === 1 && !newEmailValid) {
            this.setState({
                thirdEmailUser: PersonalDataHelper.getEmail(immProfileFields),
                newEmailValid: true
            });
        }
    }

    // go to last step
    setLastStep = () => {
        this.props.rightsActions.lastStepPortable();
    }

    // change email when on focus input
    handleEmailChange = evt => {
        const value = evt.target.value;
        const isValidEmail = this.isValidNewEmail(value);
        this.setState({
            newEmailValid: isValidEmail,
            thirdEmailUser: value,
        });
    }

    // change select options
    // handleChangeSelect = event => {
    //     this.setState({
    //         selectFilter: event.value
    //     });
    // }

    // show more information at last step
    handleShowMore = () => {
        this.setState({
            numberOfProductInfo: this.state.numberOfProductInfo + 4,
            showAllProductsInfo: !this.state.showAllProductsInfo
        });
    }

    // select or no select all products
    handleOnChangeAllProducts = () => {
        this.setState({
            productsCheckAll: !this.state.productsCheckAll,
            doActionChangeALl: !this.state.doActionChangeALl
        });
    }

    // update options to generate movements for products
    handleOnChangeShowMovements = () => {
        const { rightsActions } = this.props;
        this.setState({
            showMovements: !this.state.showMovements
        }, () => rightsActions.getMovements(this.state.showMovements));
    }

    // update profile´s object when check option
    handleOnChangeAllProfile = () => {
        const { immRightsProfile, rightsActions } = this.props;
        const { profileCheckAll } = this.state;
        const obj = profileCheckAll ? [] : [{
            numContract: '0000000000',
            movements: immRightsProfile.get('showMovements'),
            family: '00',
            consentStatus: '00'
        }] ;

        rightsActions.updateRightsProfile(obj);
        this.setState({
            profileCheckAll: !profileCheckAll
        });
    }

    // change count for all products
    handleOnChangeList = (type, list, modifyQuantity) => {
        const { doActionChangeALl, productsCheckAll, totalCountList, countCheckedList } = this.state;
        let totalAmount;
        let isAllCeck;

        if (doActionChangeALl) {
            totalAmount = productsCheckAll ? totalCountList : 0;
            isAllCeck = productsCheckAll;
        }

        this.setState({
            countCheckedList: doActionChangeALl ? totalAmount : countCheckedList + modifyQuantity,
            productsCheckAll: doActionChangeALl ? isAllCeck : countCheckedList + modifyQuantity === totalCountList,
            doActionChangeALl: false
        })

        this.props.rightsActions.updateList(type, list);
    }

    // validation for email
    isValidNewEmail (currentValue) {
        return EMAIL_REGEX.test(currentValue);
    }

    // get type error text for first step
    getTypeTooltipError (hashEmail, hashSelected) {
        let typeError = 'consents-doesntSelectCheckAndHasEmail';

        if (hashEmail && !hashSelected) {
            typeError = 'consents-doesntSelectCheck'
        } else if (!hashEmail && hashSelected) {
            typeError = 'consents-doesntHaveEmail'
        }

        return typeError;
    }

    // function when onfocus email´s imput
    handleEmailOnBlur = () => {
        const { thirdEmailUser } = this.state
        const isValidEmail = this.isValidNewEmail(thirdEmailUser);
        this.setState({
            newEmailValid: isValidEmail
        });
    }

    getIdsToPrint = () => {
        const { immRightsProfile } = this.props
        const { numberOfProductInfo } = this.state

        return (
            [
                'accountList',
                'cardCreditList',
                'cardDebitList',
                'cardEcardList',
                'plansList',
                'fundsList',
                'walletsList',
                'walletsList',
                'typeFuturesList',
                'mortgagesList',
                'loansList'
            ]
                .map(listKey => immRightsProfile.get(listKey, []).map((obj, index) => `${listKey}-${index}`))
                .reduce((lv, cv) => lv.concat(cv), [])
                .filter(l => l.length)
                .slice(0, numberOfProductInfo)
        )
    }

    // get info for all products selected
    getInfoProducts = (ids, listKey) => {
        const { immRightsProfile } = this.props
        let productInfo = null;
        const product = immRightsProfile.get(listKey, [])

        productInfo = product.map((product, index) => {
            return (
                <div className={`rights-portable-view__product-info ${ids.includes(`${listKey}-${index}`) ? '-show' : '-hidden'}`} key={index.toString()}>
                    <div className="rights-portable-view__product-info-left">
                        <b className="rights-portable-view__product-info-left-title">{product[1].title}</b>
                        <span className="rights-portable-view__product-info-left-subtitle">{product[1].subTitle}</span>
                    </div>
                    <div className="rights-portable-view__product-info-right">
                        <span>{product[1].amount}</span>
                    </div>
                </div>
            )
        });

        return productInfo;
    }

    // build wizard form
    buildWizardForm = () => {
        const { immRightsProfile, immProfileFields } = this.props;
        const { newEmailValid } = this.state;
        const immFinalButton = 'rightsAccess-finalButtonOTP';
        const stepsAccess = immRightsProfile.get('stepsPortable');
        const idsToPrint = this.getIdsToPrint() || []
        const personalInfo = immRightsProfile.get('profileList', []);

        const hasEmail = Boolean(PersonalDataHelper.getEmail(immProfileFields));
        const hasSelected = idsToPrint.length > 0 || personalInfo.length > 0;
        const nextStepToSecond = hasEmail && hasSelected;
        const typeTooltipError = this.getTypeTooltipError(hasEmail, hasSelected);
        const infoStep = this.buildInfoRightsPortable();
        const emailStep = this.buildEmailRightsPortable();
        const lastStep = this.buildLastStepRightsPortable();
        const actions = {
            finish: this.onFinish,
            setWillCancel: (() => { }),
            cancel: this.cancel,
            setVisibleStep: this.setLastStep,
            validateStep: this.setNextStep
        };

        return (
            <div className="row grid-view--content-position-negative rights-selector-view">
                <div className="col-xs-12 col-md-8 rights-portable-view__container-wizard">
                    <div className="row">
                        <Wizard
                            stepsAmount={stepsAccess.size}
                            visibleStep={immRightsProfile.get('visibleStepPortable')}
                            showPreLeaveModal={true}
                            actions={actions}
                            onConfirmLeave={() => { }}
                            immSteps={stepsAccess}
                        >
                            <WizardStep
                                position="first"
                                cancelButton={true}
                                nextButtonDisabled={!nextStepToSecond}
                                tooltipNextButton={true}
                                tooltipNextButtonContent={typeTooltipError}
                            >
                                {infoStep}
                            </WizardStep>
                            <WizardStep
                                position="middle"
                                cancelButton={true}
                                nextButtonDisabled={!newEmailValid}
                            >
                                {emailStep}
                            </WizardStep>
                            <WizardStep
                                position="last"
                                cancelButton={true}
                                previousButton={true}
                                finishButton={true}
                                addLoadingBehaviour={true}
                                immFinalButton={immFinalButton}
                            >
                                {lastStep}
                                <SignaturePattern
                                    operationType={GDPR_PORTABLE_ID}
                                    operationParams={{}}
                                />
                            </WizardStep>
                        </Wizard>
                    </div>
                </div>
            </div>
        );
    }

    // build tables which show checks and information
    buildInfoRightsPortable = () => {
        const profileAccordion = this.buildProfileAccordion();
        const productsAccordion = this.buildProductsAccordion();

        return (
            <div>
                <div className="rights-portable-view__header-wizard">
                    <h3 className="rights-portable-view__title-step">
                        <FormattedText value="rightsPortable-titleStep" />
                    </h3>
                    <p className="rights-portable-view__sub-title-step">
                        <FormattedText value="rightsPortable-subTitleStep" />
                    </p>
                </div>
                <div className="rights-portable-view__container-accordion">
                    {profileAccordion}
                </div>
                <div className="rights-portable-view__container-accordion">
                    {productsAccordion}
                </div>
            </div>
        );
    }

    // build profile info and checks information
    buildProfileAccordion = () => {
        const { profileCheckAll } = this.state;
        const injectedStrings = [profileCheckAll ? 1 : 0, 1];

        return (
            <Accordion isExpanded={false} customClassName="rights-portable-view__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition>
                    <div className="rights-portable-view__header-check-accordion">
                        <div className="check-container">
                            <OKCheckbox
                                extraClass="check-button"
                                idName="profile"
                                onChange={this.handleOnChangeAllProfile}
                                value={profileCheckAll}
                                label={

                                    <div className="title-container">
                                        <p className="title">
                                            <b><FormattedText value="rightsPortable-titleProfileSection"/></b>
                                        </p>
                                        <p className="count-selected">
                                            <FormattedText value="rightsPortable-numberChecksSelectedSection" injectedStrings={injectedStrings}/>
                                        </p>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="rights-portable-view__content-accordion">
                        <hr className="rights-portable-view__separator-wizard"/>
                        <FormattedText value="rightsPortable-descriptionProfileSection"/>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    // build products info and checks information
    buildProductsAccordion = () => {

        const {
            immAccounts,
            immCards,
            immSavings,
            immFutures,
            immFunds,
            immWallets,
            immPlans,
            immRightsProfile,
            immLoans,
            immWalletSummarization
        } = this.props;

        const {
            showMovements,
            countCheckedList,
            totalCountList,
            productsCheckAll,
            doActionChangeALl,
            selectFilter
        } = this.state;

        const injectedStrings = [countCheckedList, totalCountList];

        return (
            <Accordion isExpanded={true} customClassName="rights-portable-view__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition>
                    <div className="rights-portable-view__header-check-accordion">
                        <div className="check-container">
                            <OKCheckbox
                                extraClass="check-button"
                                idName="products"
                                value={productsCheckAll}
                                onChange={this.handleOnChangeAllProducts}
                                label={
                                    <div className="title-container">
                                        <p className="title">
                                            <b><FormattedText value="rightsPortable-titleProductSection"/></b>
                                            <div className="rights-portable-view__tooltip-accordion">
                                                {/*<OKTooltip
                                                    content={
                                                        <div className="rights-portable-view__tooltip-accordion-content">
                                                            <FormattedText value="rightsPortable-tooltipProductsAccordion" />
                                                        </div>
                                                    }
                                                    type="custom"
                                                />*/}
                                            </div>
                                        </p>
                                        <p className="count-selected">
                                            <FormattedText value="rightsPortable-numberChecksSelectedSection" injectedStrings={injectedStrings} />
                                        </p>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody" isExpanded={true}>
                    <div className="rights-portable-view__content-accordion">
                        <hr className="rights-portable-view__separator-wizard"/>
                        <OKCheckbox
                            extraClass="check-button"
                            idName="movementsProducts"
                            value={showMovements}
                            onChange={this.handleOnChangeShowMovements}
                            label={
                                <div className="rights-portable-view__profile-check">
                                    <FormattedText value="rightsPortable-includeMovementsCheck"/>
                                </div>
                            }
                        />
                        {/*
                            <div className="rights-portable-view__select-filter">
                                <OKSelect
                                    name="filter-rights"
                                    placeholder="Todos mis productos"
                                    onChange={this.handleChangeSelect}
                                    value={this.state.selectFilter}
                                    options={selectFilterOptions}
                                    searchable={false}
                                    clearable={false}
                                />
                            </div>
                        */}
                    </div>
                    <div className="rights-portable-view__content-accordion">
                        <PortableProductsAccordion
                            onUpdateList={this.handleOnChangeList}
                            allChecksHeadersStatus={productsCheckAll}
                            doActionChangeALl={doActionChangeALl}
                            immRightsProfile={immRightsProfile}
                            immCards={immCards}
                            immAccounts={immAccounts}
                            immSavings={immSavings}
                            immFutures={immFutures}
                            immFunds={immFunds}
                            immPlans={immPlans}
                            immWallets={immWallets}
                            immLoans={immLoans}
                            selectFilter={selectFilter}
                            immWalletSummarization={immWalletSummarization}
                        />
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    // build email step
    buildEmailRightsPortable = () => {
        const { thirdEmailUser } = this.state
        const { immProfileFields } = this.props;
        const oldEmailUser = PersonalDataHelper.getEmail(immProfileFields);

        return (
            <div>
                <div className="rights-portable-view__header-wizard">
                    <h3 className="rights-portable-view__title-step">
                        <FormattedText value="rightsPortable-titleEmailStep" />
                    </h3>
                    <p className="rights-portable-view__sub-title-step">
                        <FormattedText value="rightsPortable-subTitleEmailStep" injectedStrings={[oldEmailUser, oldEmailUser]} />
                    </p>
                </div>
                <hr className="rights-portable-view__separator-wizard"/>
                <div className="row">
                    <div className="rights-portable-view__list-wizard col-xs-12 col-md-6">
                        <InputSafe
                            label={<FormattedText value="rightsPortable-emailInputLabel" />}
                            name="email"
                            type="email"
                            onChange={this.handleEmailChange}
                            onBlur={this.handleEmailOnBlur}
                            value={thirdEmailUser}
                            errorState={!this.state.newEmailValid}
                        />
                    </div>
                </div>
            </div>
        );
    }

    // build last step with all the info about products selected
    buildLastStepRightsPortable = () => {

        const { thirdEmailUser, numberOfProductInfo } = this.state;
        const { immRightsProfile, immProfileFields } = this.props;
        const oldEmailUser = PersonalDataHelper.getEmail(immProfileFields);
        const personalInfo = immRightsProfile.get('profileList').length > 0;
        const totalProductSelected = rightsProfileHelper.getTotalProducts(immRightsProfile);
        const idsToPrint = this.getIdsToPrint() || []
        const accountsInfo = this.getInfoProducts(idsToPrint, 'accountList');
        const creditInfo = this.getInfoProducts(idsToPrint, 'cardCreditList');
        const debitInfo = this.getInfoProducts(idsToPrint, 'cardDebitList');
        const eCardInfo = this.getInfoProducts(idsToPrint, 'cardEcardList');
        const plansInfo = this.getInfoProducts(idsToPrint, 'plansList');
        const fundsInfo = this.getInfoProducts(idsToPrint, 'fundsList');
        const walletsInfo = this.getInfoProducts(idsToPrint, 'walletsList');
        const futuresInfo = this.getInfoProducts(idsToPrint, 'typeFuturesList');
        const mortgagesInfo = this.getInfoProducts(idsToPrint, 'mortgagesList');
        const loansInfo = this.getInfoProducts(idsToPrint, 'loansList');
        const textEmail = thirdEmailUser === oldEmailUser ? <FormattedText value="rightsPortable-subTitleLastStepPortable" injectedStrings={[oldEmailUser]} /> : <FormattedText value="rightsPortable-subTitleLastStepPortableNewEmail" injectedStrings={[oldEmailUser, thirdEmailUser]} />

        return(
            <div>
                <div className="rights-portable-view__header-wizard">
                    <h3 className="rights-portable-view__title-step">
                        <FormattedText value="rightsPortable-titleLastStepPortable" />
                    </h3>
                    <p className="rights-portable-view__sub-title-step">
                        {textEmail}
                    </p>
                </div>
                <hr className="rights-portable-view__separator-wizard"/>
                <div className="row rights-portable-view__info-products">
                    {
                        personalInfo && <div className="col-xs-12 rights-portable-view__personal-info">
                            <FormattedText value="rightsPortable-personalInfo" />
                        </div>
                    }
                    <div className="col-xs-8">
                        {accountsInfo}
                        {creditInfo}
                        {debitInfo}
                        {eCardInfo}
                        {plansInfo}
                        {fundsInfo}
                        {walletsInfo}
                        {futuresInfo}
                        {mortgagesInfo}
                        {loansInfo}
                    </div>
                </div>
                {
                    totalProductSelected > numberOfProductInfo &&
                    <OKLink className="rights-portable-view__button-show-more" modifier="emphasize" onClick={this.handleShowMore}>
                        <FormattedText value="rightsPortable-moreProductsButton" />
                    </OKLink>
                }
                <hr className="rights-portable-view__separator-wizard"/>
            </div>
        )
    }

    // build wizard success
    buildWizardSuccess = () => {

        const { immProfileFields } = this.props;
        const { thirdEmailUser } = this.state;
        const oldEmailUser = PersonalDataHelper.getEmail(immProfileFields);
        const goBackButtonLabel = formatText('rightsPortable-goBackButton').toUpperCase();
        const sendToOtherEmail = oldEmailUser != thirdEmailUser;
        const injectedStrings = sendToOtherEmail ? [thirdEmailUser, oldEmailUser] : [oldEmailUser];
        const textKey = sendToOtherEmail ? 'rightsPortable-descriptionSuccessDifferentEmail' : 'rightsPortable-descriptionSuccess';
        const goBackButton = {
            label: goBackButtonLabel,
            url: '/myprofile/edit'
        }

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8 rights-portable-view__container-wizard">
                    <div className="row">
                        <WizardSuccess
                            successMessage={formatText('rightsPortable-successStepTitle')}
                            mainButton={goBackButton}
                            successSubMessage={
                                <FormattedText
                                    value={textKey}
                                    injectedStrings={injectedStrings}
                                />
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    getError (error) {
        if (error == 409)
            return 'rightsPortable-errorMessageWizardRequestInProgress'
        if (error == 477)
            return 'rightsPortable-errorMessageWizardNoEmail'
        return 'rightsPortable-errorMessageWizard'

    }

    // build wizard error
    buildWizardError = error => {
        const errorTitle = formatText('rightsPortable-errorTitleWizard');
        const errorMessage = formatText(this.getError(error));
        const goBackButtonLabel = formatText('rightsPortable-goBackButton').toUpperCase();
        const goBackButton = {
            label: goBackButtonLabel,
            url: '/myprofile/edit'
        }
        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8 rights-portable-view__container-wizard">
                    <div className="row">
                        <WizardError
                            errorMessage={errorTitle}
                            errorSubMessage={errorMessage}
                            mainButton={goBackButton}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render () {
        const { immRightsProfile } = this.props;
        const portableSuccess = immRightsProfile.get('successPortable');
        const portableError = immRightsProfile.get('errorPortable');
        let wizard;

        if (!portableSuccess && !portableError) {
            wizard = this.buildWizardForm();
        } else if (portableSuccess && !portableError) {
            wizard = this.buildWizardSuccess();
        } else if (!portableSuccess && portableError) {
            wizard = this.buildWizardError(portableError);
        }

        const breadcrumb = [
            {
                text: formatText('breadcrumb-personalInformation'),
                url: '/myprofile/edit'
            },
            {
                text: formatText('breadcrumb-selectorRights'),
                url: '/myprofile/rights'
            },
            {
                text: formatText('breadcrumb-rightsPortableView'),
                url: '/myprofile/rights'
            }
        ];

        return (
            <div className="rights-portable-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumb}
                                finalTitle={getFinalTitle('breadcrumb-rightsPortableView')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {wizard}
                    </div>
                </div>
            </div>
        );
    }
}

RightsPortableView.propTypes = {
    immRightsProfile: PropTypes.object,
    rightsActions: PropTypes.object,
    immAccounts: PropTypes.object,
    immSavings: PropTypes.object,
    immCards: PropTypes.object,
    immProfileFields: PropTypes.object,
    immWallets: PropTypes.object,
    immFutures: PropTypes.object,
    immFunds: PropTypes.object,
    immLoans: PropTypes.object,
    immPlans: PropTypes.object,
    immWalletSummarization: PropTypes.object,
    history: PropTypes.object.isRequired
}

module.exports.constructor = RightsPortableView;

module.exports.RightsPortableView = connect(
    state => ({
        immRightsProfile: state.rightsProfile,
        immProfileFields: state.profile,
        immCards: state.cards,
        immAccounts: state.accounts,
        immSavings: state.globalPosition.getIn(['savings', 'allSavings']),
        immWallets: state.brokerWallets.get('walletList'),
        immFutures: state.brokerWallets.get('futuresList'),
        immFunds: state.brokerWallets.get('fundsList'),
        immPlans: state.brokerWallets.get('plansList'),
        immWalletSummarization: state.brokerWallets.get('walletSummarization'),
        immLoans: state.loans,
    }),
    dispatch => ({
        rightsActions: bindActionCreators(rightsActions, dispatch),
    })
)(withRouter(RightsPortableView));
